/**
 * Conversation (chat history) API service
 */
import apiClient from './apiClient';
import type { Conversation, ConversationSummary } from '../types';

const BASE = '/conversations';

export const conversationService = {
  async listConversations(): Promise<ConversationSummary[]> {
    const res = await apiClient.get<{ success: boolean; conversations: ConversationSummary[] }>(BASE);
    if (!res.data.success || !Array.isArray(res.data.conversations)) return [];
    return res.data.conversations;
  },

  async createConversation(title?: string): Promise<Conversation> {
    const res = await apiClient.post<{ success: boolean; conversation: Conversation }>(BASE, {
      title: title || 'New conversation',
    });
    if (!res.data.success || !res.data.conversation) throw new Error('Failed to create conversation');
    return res.data.conversation;
  },

  async getConversation(id: string): Promise<Conversation | null> {
    try {
      const res = await apiClient.get<{ success: boolean; conversation: Conversation }>(`${BASE}/${id}`);
      if (!res.data.success || !res.data.conversation) return null;
      return res.data.conversation;
    } catch (err: unknown) {
      const ax = err as { response?: { status: number } };
      if (ax.response?.status === 404) return null;
      throw err;
    }
  },

  async renameConversation(id: string, title: string): Promise<void> {
    await apiClient.patch(`${BASE}/${id}`, { title });
  },

  async deleteConversation(id: string): Promise<void> {
    await apiClient.delete(`${BASE}/${id}`);
  },
};
